import { render, staticRenderFns } from "./delScene.vue?vue&type=template&id=e35471c6&scoped=true"
import script from "./delScene.vue?vue&type=script&lang=js"
export * from "./delScene.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35471c6",
  null
  
)

export default component.exports